import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import WorkdayDurationsEditor from '../../../../controls/WorkdayDurationsEditor'
import CustomCheckbox from '../../../../components/customCheckbox/CustomCheckbox'
import UserTime from '../../../../user_time'
import {getInstance as getModalAlert} from '../../UserPanelModalAlert'
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'

export default class InitialScheduleRow extends TemplateView {
    constructor({
        readOnly = false,
        scheduleHeaderLabel = '',
        scrollTo = () => {},
        onChangeCb = () => {},
    }) {
        super()

        this.params = {
            readOnly,
            scheduleHeaderLabel,
            scrollTo,
        }

        this.callbacks = {
            onChangeCb,
        }

        this.state = {
            initialSchedule: [],
            isDefaultInitialSchedule: false,
            weekStartDay: 0,
            effective: false,
            readOnly: this.params.readOnly,
        }

        this.onStateChanged(() => this._update())
    }

    templateHtml() {
        return '<div class="workScheduleRow">' +
               '    <div class="workSchedule">' +
               '        <div class="headerCell">' +
               '            <div class="scheduleHeaderLabel"><%=scheduleHeaderLabel%></div>' +
               '            <div class="current"><%=dateFromLabel%></div>' +
               '        </div>' +
               '        <div class="workScheduleEditorCell"/>' +
               '        <div class="totalCell"/>' +
               '        <div class="useDefaultScheduleCell">' +
               '            <div class="usedDefaultScheduleLabel"><%-usedCorporateSettings%></div>' +
               '        </div>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            dateFromLabel: this.params.dateFromLabel,
            scheduleHeaderLabel: this.params.scheduleHeaderLabel,
        }
    }

    messageKeys() {
        return {
            usedCorporateSettings: 'user.add_edit.js.wd_editor.used_corporate_settings',
        }
    }

    afterRender() {
        this.$workschedule = this.find('.workSchedule')
        this.$workdayDurationsPlaceholder = this.find('.workScheduleEditorCell')
        this.$totalCell = this.find('.totalCell')
        this.$usedDefaultScheduleLabel = this.find('.usedDefaultScheduleLabel')

        this.useDefaultScheduleCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('user.add_edit.js.wd_editor.use_corporate_settings'),
            containerAdditionalClass: 'useDefaultScheduleCheckbox',
            onChange: ({checked}) => this._handleChanged({isDefaultInitialSchedule: checked}),
        }).init(this.find('.useDefaultScheduleCell'))
    }

    _update() {
        this.$workdayDurationsPlaceholder.empty()
        this.$workschedule.toggleClass('effective', this.state.effective)

        this.workdayDurationsEditor = new WorkdayDurationsEditor().init(
            this.state.initialSchedule.slice(),
            this.state.weekStartDay,
            () => {
                if (this.workdayDurationsEditor.hasErrors()) {
                    this._handleWorkdayDurationEditorError()
                } else {
                    this._handleChanged({
                        isDefaultInitialSchedule: false,
                        initialSchedule: this.workdayDurationsEditor.getDurations()
                    })
                }
            },
            false,
            null,
            window.SystemSettings.decimalSeparator,
            this.state.readOnly
        )
        const showCorporateCheckbox = !this.state.readOnly && this.state.effective

        this.workdayDurationsEditor.renderTo(this.$workdayDurationsPlaceholder[0])
        this.workdayDurationsEditor.setInputDisabled(this.state.isDefaultInitialSchedule && showCorporateCheckbox || this.state.readOnly)

        this.$totalCell.text(UserTime.formatTime(WorkdayDurationsEditor.sumDurations(this.state.initialSchedule)))

        this.useDefaultScheduleCheckbox.setState({
            checked: this.state.isDefaultInitialSchedule,
            disabled: !showCorporateCheckbox
        })
        this.useDefaultScheduleCheckbox.toggle(showCorporateCheckbox)
        this.$usedDefaultScheduleLabel.toggle(this.state.readOnly && this.state.isDefaultInitialSchedule)
    }

    _handleChanged(changes) {
        const {initialSchedule, isDefaultInitialSchedule} = {...this.state, ...changes}
        this.callbacks.onChangeCb({initialSchedule, isDefaultInitialSchedule})
    }

    _handleWorkdayDurationEditorError() {
        const $invalidWorkDayCell = this.find(`.${this.workdayDurationsEditor.getTableClassName()} td.error`)
        const msg = messageResource.getMessage('rates.editor.work_schedule.day_value.error', [window.SystemSettings.decimalSeparator]) + '\n' +
                    messageResource.getMessage('rates.editor.modifications_will_be_discarded')

        this.params.scrollTo($invalidWorkDayCell)

        getModalAlert().setState({
            text: msg,
            pointerPosition: ModalAlertPointerPosition.CENTER
        }).showAt($invalidWorkDayCell, () => {
            this.setState({initialSchedule: this.state.initialSchedule})
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/InitialScheduleRow.js